import { trailingSlashEnd } from "./utils";

export function replaceCdnLinksForDev(releases) {
  return releases.map((release) => {
    if (process.env.NODE_ENV === "development" && release.textFileLink) {
      release.textFileLink = release.textFileLink.replace(
        trailingSlashEnd(process.env.REACT_APP_CDN_URL),
        "/cdn",
      );
    }
    return release;
  });
}
